var map = {
	"./box.png": "f0ac",
	"./business.png": "d3f5",
	"./empty.png": "fa1c",
	"./live.png": "149f",
	"./queue.png": "496f",
	"./score.png": "2efa",
	"./search.png": "3071",
	"./vs.png": "b8d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c941";